var App = App || {};

App.BackToTop = (function ($) {
    'use strict';

    function init() {
    
        $(".component-back-to-top .btn-top").on("click", function () {
            var duration = 100,
                offset = $(".component-page-masthead").outerHeight() + $(".site-header").outerHeight();

            if (matchMedia("screen and (max-width: 992px)").matches) {
                var offset = $(".component-page-masthead").outerHeight() + $(".site-header").outerHeight() - 200
            }

            $('html, body').stop()
                .animate({
                    scrollTop: offset
                }, duration);
        })
    }

    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();

        // Example: Display an item when the scroll position reaches a certain point
        if (scrollTop > 400) {
            $(".component-back-to-top").fadeIn();
        } else {
            $(".component-back-to-top").fadeOut();
        }
    });

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BackToTop.init();
});